import { Pipe, PipeTransform } from '@angular/core';
import { Setor } from '../../modelos/setor';

@Pipe({
  name: 'filtroSetores'
})
export class FiltroSetoresPipe implements PipeTransform {

  transform(setores: Setor[], filtro?: string): any {
    if (setores === undefined || filtro === undefined || filtro.trim() === '') {
      return setores;
    }
    filtro = filtro.toLocaleLowerCase();
    return setores.filter(setor => setor.nomeSetor.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-setores.pipe.ts